import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import colors from './Colors';
import { Box, TextField, Button, Typography } from '@material-ui/core';
import { FONT_SIZE_LABEL } from '../utils';
import classnames from 'classnames';

const useStyles = makeStyles(theme => ({
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }, fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    underlineError: {
        '&::after': {
            borderBottom: '2px solid' + '#eb5a4d !important'
        }
    },
    underlineWhite: {
        '&::before': {
            borderBottom: '1px solid' + colors.white['50']
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid' + colors.white['50']
        },
        '&::after': {
            border: '1px solid white'
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    titleCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: " #4f5064",
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: '#eb5a4d !important',
    },
    textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#88898c',

    },
    textLableError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#eb5a4d !important',
    },
    buttonFontSize: {
        marginLeft: '5px',
        marginTop: '5px',
        minHeight: '24px',
        minWidth: '30px',
        width: '22px',
        height: '24px',
        borderRadius: 3
    },
    buttonFontSizeInactive: {
        backgroundColor: '#f3f7fa',
    },
    resize1: {
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: '  19px',
        letterSpacing: "0.13px",
        color: "#4f5064",
        position: "absolute",
        alignSelf: 'baseline',
        height: 100,
        marginLeft: 15,
        marginTop: -15,
        maxWidth: 455,

    },
    resize2: {
        fontSize: '13px',
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: '  19px',
        letterSpacing: "0.13px",
        color: "#4f5064",
        position: "absolute",
        alignSelf: 'baseline',
        height: 100,
        marginLeft: 15,
        marginTop: -15,
        maxWidth: 455,

    },
    resize3: {
        fontSize: '15px',
        fontWeight: 500,
        fontStretch: "normal",
        lineHeight: '  19px',
        letterSpacing: "0.13px",
        color: "#4f5064",
        position: "absolute",
        alignSelf: 'baseline',
        height: 100,
        marginLeft: 15,
        marginTop: -15,
        maxWidth: 455,
    },
    label1: {
        position: 'absolute',
        fontFamily: "UniviaPro",
        fontSize: '7px',
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#ffffff ",
    },
    label2: {
        position: 'absolute',
        fontFamily: "UniviaPro",
        fontSize: '10px',
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#ffffff ",
    },
    label3: {
        position: 'absolute',
        fontFamily: "UniviaPro",
        fontSize: '13px',
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#ffffff",
    },
    TextFontSizeInactive: {
        color: "#4f5064",
    },
    resizeInfoPage1: {
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: '  19px',
        letterSpacing: "0.13px",
        color: "#4f5064",
        position: "absolute",
        alignSelf: 'baseline',
        height: 100,
        marginLeft: 15,
        marginTop: -15,
        maxWidth: 430,
    },
    resizeInfoPage2: {
        fontSize: '13px',
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: '  19px',
        letterSpacing: "0.13px",
        color: "#4f5064",
        position: "absolute",
        alignSelf: 'baseline',
        height: 100,
        marginLeft: 15,
        marginTop: -15,
        maxWidth: 430,
    },
    resizeInfoPage3: {
        fontSize: '15px',
        fontWeight: 500,
        fontStretch: "normal",
        lineHeight: '  19px',
        letterSpacing: "0.13px",
        color: "#4f5064",
        position: "absolute",
        alignSelf: 'baseline',
        height: 100,
        marginLeft: 15,
        marginTop: -15,
        maxWidth: 430,
    },
}));

const CustomTextFiled = ({ infoPage, fontSize, setFontSize, isDyslexieEnable, endDom, ...props }) => {
    const classes = useStyles();

    const btnFontSizeSmall = fontSize === FONT_SIZE_LABEL.SMALL ? classes.buttonFontSize : classnames(classes.buttonFontSize, classes.buttonFontSizeInactive)
    const btnFontSizeMedium = fontSize === FONT_SIZE_LABEL.MEDIUM ? classes.buttonFontSize : classnames(classes.buttonFontSize, classes.buttonFontSizeInactive);
    const btnFontSizeLarge = fontSize === FONT_SIZE_LABEL.LARGE ? classes.buttonFontSize : classnames(classes.buttonFontSize, classes.buttonFontSizeInactive);

    const txtFontSizeSmall = fontSize === FONT_SIZE_LABEL.SMALL ? classes.label1 : classnames(classes.label1, classes.TextFontSizeInactive)
    const txtFontSizeMedium = fontSize === FONT_SIZE_LABEL.MEDIUM ? classes.label2 : classnames(classes.label2, classes.TextFontSizeInactive);
    const txtFontSizeLarge = fontSize === FONT_SIZE_LABEL.LARGE ? classes.label3 : classnames(classes.label3, classes.TextFontSizeInactive);

    return (
        <Box>
            <TextField
                {...props}
                FormHelperTextProps={{
                    className: classes.textError
                }}
                InputLabelProps={{
                    // className: classes.textLabel,
                    classes: {
                        root: classes.textLabel,
                        error: classes.textLableError
                    }
                }}
                InputProps={{
                    endAdornment: endDom,
                    startAdornment: <Box display='flex' style={{ position: 'absolute', bottom: '20px' }}>
                        <Button variant="contained" color={fontSize === FONT_SIZE_LABEL.SMALL ? "primary" : "default"} className={btnFontSizeSmall} classes={{ label: classes.label1 }} onClick={() => setFontSize(FONT_SIZE_LABEL.SMALL)}><Typography className={txtFontSizeSmall} >A</Typography></Button>
                        <Button variant="contained" color={fontSize === FONT_SIZE_LABEL.MEDIUM ? "primary" : "default"} className={btnFontSizeMedium} classes={{ label: classes.label2 }} onClick={() => setFontSize(FONT_SIZE_LABEL.MEDIUM)}><Typography className={txtFontSizeMedium} >A</Typography></Button>
                        <Button variant="contained" color={fontSize === FONT_SIZE_LABEL.LARGE ? "primary" : "default"} className={btnFontSizeLarge} classes={{ label: classes.label3 }} onClick={() => setFontSize(FONT_SIZE_LABEL.LARGE)}><Typography className={txtFontSizeLarge} >A</Typography></Button>
                    </Box>,
                    className: classes.input,
                    classes: {
                        underline: props.error ? classes.underlineError : (props.value !== '' ? classes.underline : classes.underlineNotValue),
                        focused: classes.focuses,
                        input: !infoPage ? (fontSize === FONT_SIZE_LABEL.SMALL ? classes.resize1 : (fontSize === FONT_SIZE_LABEL.MEDIUM ? classes.resize2 : classes.resize3)) :
                            (fontSize === FONT_SIZE_LABEL.SMALL ? classes.resizeInfoPage1 : (fontSize === FONT_SIZE_LABEL.MEDIUM ? classes.resizeInfoPage2 : classes.resizeInfoPage3)),
                    },
                    style: { fontFamily: isDyslexieEnable ? 'Dyslexie' : 'UniviaPro', minHeight:'350px' },
                }}
                variant="filled"
            />
        </Box>
    )
}

export default CustomTextFiled;
